import React from 'react'
import WarningGreenSvg from '../../assets/icons/WarningGreenSvg'

const acceptList = [
  {
    id: 0,
    text: 'Tanımladığım misafir(ler)in hobi bahçesi kullanım alanı içerisinde gerçekleştirdiği her türlü olumsuz davranıştan 1.derecede sorumlu olduğumu kabul ediyorum.',
  },
  {
    id: 1,
    text: 'Tanımladığım misafir(ler)in hobi bahçesi tahsis ve kullanım sözleşmesinde yer alan adli ve ahlaki şartları sağladığını kabul ve beyan ediyorum.',
  },
  {
    id: 2,
    text: 'Tanımladığım misafir(ler)den kaynaklı oluşacak olumsuz bir durumda hobi bahçesi tahsis ve kullanım sözleşmemin idare tarafından tek taraflı olarak fesih edilebileceğini ve hiçbir hak talep edemeyeceğimi kabul ediyorum.',
  },
  {
    id: 3,
    text: 'Yetkilendirme işlemi sonucunda gönderilecek kısa mesajda yer alan işlem bağlantısı yetkilendirme yapılan gün içerisinde geçerlidir.',
  },
]

const RulesModalBody = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '.8rem',
        padding: '.6rem 0 0 0',
      }}
    >
      <WarningGreenSvg width={'4rem'} />
      <div
        style={{
          fontSize: '16px',
          fontWeight: '700',
        }}
      >
        Misafir Tanımlama Kuralları
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'start',
          gap: '.8rem',
        }}
      >
        {acceptList?.map((item) => (
          <div
            key={item.id}
            style={{
              display: 'inline-flex',
              gap: '.8rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'start',
                color: '#fff',
                padding: '.1rem .5rem',
                borderRadius: '50%',
                backgroundColor: '#205c42',
              }}
            >
              {item.id + 1}
            </div>
            <div>{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RulesModalBody
